<template>
    <div class="tool">
        <div class="left" @click="$router.push('/selectUnit')">
            <Icon name="setting-o" size="24"/>
        </div>
        <div class="unit-name">{{unitTitle}}</div>
        <div class="right" @click="$router.push('/message')">
            <Icon name="chat-o" size="24" dot/>
        </div>
    </div>
</template>

<script>
    import {Icon} from "vant"
    import WeChatIcon from "@/components/Icon/WeChatIcon"

    export default {
        components: {WeChatIcon, Icon},
        props: {},
        data() {
            return {}
        },
        computed: {
            unitTitle() {
                const {unitOrOrgan} = this.$default
                return unitOrOrgan.name
            }
        },
        created() {
        },
        mounted() {
        },
        methods: {},
        watch: {}
    }
</script>

<style lang="less" scoped>
    .tool {
        height: 80px;
        display: flex;
        align-items: center;
        & > div {
            height: 40px;
            display: flex;
            justify-content: center;
            align-items: center;
        }
        & > .left {
            width: 80px;
        }
        & > .unit-name {
            width: 100%;
            font-size: 18px;
        }
        & > .right {
            width: 80px;
        }
    }
</style>